import { initializeCarousel } from "./components/glideInit";

/**
 * updates the current bullet state 
 * @param {jQuery} $carouselElement container element
 */
function updateBulletState($carouselElement) {
    var $bullets = $carouselElement.find('.glide__bullet');
    $bullets.removeAttr('aria-current');
    $bullets.filter('.glide__bullet--active').attr('aria-current', 'true');
}

/**
 * updates the current slide 
 * @param {jQuery} $carousel container element
 */
function updateSlideAccessibility($carousel) {
    var $slides = $carousel.find('.glide__slides > .glide__slide').not('.glide__slide--clone');
    var total = $slides.length;

    $slides.each(function (index) {
        var $slide = $(this);
        var isActive = $slide.hasClass('glide__slide--active');

        $slide.attr({
            role: 'group',
            'aria-roledescription': 'slide',
            'aria-label': (index + 1) + ' of ' + total
        });

        $slide.toggleClass('is-accessible-active', isActive);
    });
}

(function () {
    $('.js-mbb-carousel').each(function () {
        const $carousel = $(this);
        const autoPlay = $carousel.attr('data-autoplay') === '0' || $carousel.attr('data-autoplay') === 'false' ? false : parseInt($carousel.attr('data-autoplay'), 10)
        
        const defaults = {
            type: 'carousel',
            gap: 0,
            autoplay: autoPlay,
            animationDuration: 1000
        };

        initializeCarousel($carousel , defaults, true);
        
        setTimeout(function () {
            updateBulletState($carousel);
            updateSlideAccessibility($carousel);
        },100);
    });

    $(document).on('click', '.glide__arrow--right', function () {
        var $nextButton = $(this);
        setTimeout(function () {
            var $activeSlide = $nextButton.closest('.glide__container').siblings('.glide__track');
            $activeSlide.find('.glide__slide--active .mbb-hero__cta-button-list a').first().focus();
        }, 1100);
    });

    $(document).on('click', '.js-mbb-carousel .glide__arrow, .js-mbb-carousel .glide__bullet', function () {
        var $element = $(this);
        setTimeout(function () {
            var $currentGlideElement = $element.parents('.glide__bullets').find('.glide__bullet');
            $currentGlideElement.removeAttr('aria-current');
            $currentGlideElement.filter('.glide__bullet--active').attr('aria-current', 'true');
        },1000);
    });
})();